export const VISITOR_BEHAVIOR_GET_ALL_SUCCESS = 'VISITOR_BEHAVIOR_GET_ALL_SUCCESS';
export const VISITOR_BEHAVIOR_GET_ALL_FAILURE = 'VISITOR_BEHAVIOR_GET_ALL_FAILURE';
export const VISITOR_BEHAVIOR_DATA_IS_LOADING = 'VISITOR_BEHAVIOR_DATA_IS_LOADING';

export const VISITOR_BEHAVIOR_GET_ALL_PERCENTAGES_SUCCESS = 'VISITOR_BEHAVIOR_GET_ALL_PERCENTAGES_SUCCESS';
export const VISITOR_BEHAVIOR_GET_ALL_PERCENTAGES_FAILURE = 'VISITOR_BEHAVIOR_GET_ALL_PERCENTAGES_FAILURE';
export const VISITOR_BEHAVIOR_PERCENTAGE_DATA_IS_LOADING = 'VISITOR_BEHAVIOR_PERCENTAGE_DATA_IS_LOADING';
